import chargerIconSVG from '../../assets/icons/charger-color.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const ChargerColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chargerIconSVG} {...props} />;
};
